import {
  BoxProps,
  FormLabel,
  FormLabelProps,
  forwardRef,
  Link,
  HStack,
} from '@chakra-ui/react';

import IsRequiredStar from 'components/atoms/form/isRequiredStar';

import { VariantsAvailable, variants } from './variants';

export interface FieldTitleProps extends FormLabelProps {
  variant?: VariantsAvailable;
  label?: string;
  isRequired?: boolean;
  starColor?: BoxProps['color'];
  disabled?: boolean;
  helpLabel?: string;
  helpLinkedLabel?: string;
  helpLink?: string;
}

export const FieldTitle = forwardRef<FieldTitleProps, 'label'>(
  (
    {
      variant = 'standard',
      starColor,
      isRequired,
      label,
      helpLabel,
      helpLinkedLabel,
      helpLink,
      ...props
    },
    ref
  ) => {
    if (!label) {
      return <></>;
    }

    return (
      <HStack alignItems='middle' spacing={1}>
        <FormLabel
          ref={ref}
          color='text.100'
          fontWeight='700'
          fontSize='sm'
          mb={4}
          mr={0}
          {...variants[variant]}
          {...props}
        >
          {label}
          {isRequired && <IsRequiredStar color={starColor} />}
        </FormLabel>
        {helpLabel && helpLinkedLabel && helpLink && (
          <>
            <FormLabel color='text.100' fontWeight='500' fontSize='sm'>
              <Link
                color='primary.500'
                fontWeight='500'
                href={helpLink}
                fontSize='sm'
              >
                {helpLinkedLabel}
              </Link>{' '}
              {helpLabel}
            </FormLabel>
          </>
        )}
      </HStack>
    );
  }
);

FieldTitle.displayName = 'FieldTitle';
